/**
 * Created by baird on 2017/6/23.
 */
import BaseService from './BaseService';
import StorageService from './StorageService';
const localStorage = new StorageService('local');
class AddressService extends BaseService {
    constructor() {
        super();
        this.url = '/api/area/'
    }

    /*ʡ*/
    getProvinces() {
        let key = 'get_provinces';
        if (localStorage.get(key)&&localStorage.get(key).length>0) {
            return this.createPromise(() => {
                return localStorage.get(key);
            });
        }
        return this.request(this.url + key).then((ret) => {
            localStorage.set(key, ret);
            return ret;
        });
    }

    /*��*/
    getcitys(ID) {
        let key = 'get_citys' + '/' + ID;
        if (localStorage.get(key)&&localStorage.get(key).length>0) {
            return this.createPromise(() => {
                return localStorage.get(key);
            });
        }
        return this.request(this.url + key).then((ret) => {
            localStorage.set(key, ret);
            return ret;
        });
    };

    /*��*/
    getareas(ID) {
        let key = 'get_areas' + '/' + ID;
        if (localStorage.get(key)&&localStorage.get(key).length>0) {
            return this.createPromise(() => {
                return localStorage.get(key);
            });
        }
        return this.request(this.url + key).then((ret) => {
            localStorage.set(key, ret);
            return ret;
        });
    }

    createPromise(callback, time = 0) {
        return new Promise(function (resolve) {
            setTimeout(() => {
                resolve(callback());
            }, time);
        });
    }
}
export default new AddressService();



// WEBPACK FOOTER //
// ./src/services/AddressService.js